import { render, staticRenderFns } from "./SetariLucrari.vue?vue&type=template&id=37084069"
import script from "./SetariLucrari.vue?vue&type=script&lang=js"
export * from "./SetariLucrari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports